export default class Emitter {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    exec() {
        if ( typeof this[this.gb.gameProviderProtocol + "_" + this.gb.walletProtocol + "_handler"] === "function"){
            this.usingHandler = this.gb.gameProviderProtocol + "_" + this.gb.walletProtocol + "_handler";
            this[this.gb.gameProviderProtocol + "_" + this.gb.walletProtocol + "_handler"].apply(this, arguments);

        }else if (this[this.gb.walletProtocol + "_handler"] && typeof this[this.gb.walletProtocol + "_handler"] === "function") {
            this.usingHandler = this.gb.walletProtocol;
            this[this.gb.walletProtocol + "_handler"].apply(this, arguments);
        } else {
            this.usingHandler = "_default";
            this._default.apply(this, arguments);
        }
    }

    emitParent(msg) {
        if (this.gb.utils && this.gb.utils.isIframe !== true) {
            logger.debug(`Suppressing '${this.constructor.name}' to ${this.usingHandler} WEB (to parent), since not in iframe!`, msg);
            return;
        }

        if (msg.wpgaction) {
            msg.eventName = msg.wpgaction;
        }

        if (this.gb.settings.stringifyWalletMsgs === true) {
            if (typeof msg !== "string") {
                msg = JSON.stringify(msg);
            }
        }

        window.parent.postMessage(msg, "*");

        logger.debug(`Emitting '${this.constructor.name}' to ${this.usingHandler} WEB (to parent)`, msg);
    }

    emitTop(msg) {
        if (this.gb.utils && this.gb.utils.isIframe !== true) {
            logger.debug(`Suppressing '${this.constructor.name}' to ${this.usingHandler} WEB (to top window), since not in iframe!`, msg);
            return;
        }

        if (msg.wpgaction) {
            msg.eventName = msg.wpgaction;
        }

        if (this.gb.settings.stringifyWalletMsgs === true) {
            if (typeof msg !== "string") {
                msg = JSON.stringify(msg);
            }
        }

        window.top.postMessage(msg, "*");

        logger.debug(`Emitting '${this.constructor.name}' to ${this.usingHandler} WEB (to top window)`, msg);
    }

    emitiOS(msg) {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.gameBridgeMessageHandler) {
            window.webkit.messageHandlers.gameBridgeMessageHandler.postMessage(msg);
            logger.debug(`Emitting '${this.constructor.name}' to ${this.usingHandler} iOS (to WKwebview)`, msg);
        }
    }

    emitSelf(msg) {
        window.postMessage(msg, "*");
        logger.debug(`Emitting '${this.constructor.name}' to ${this.usingHandler} current window (for Notification widget)`, msg);
    }
}
